import React, {Component} from 'react';

export default class Modal extends Component {

	render() {
		return(
			<div id={this.props.id} className="modal fade in col-md-4" tabIndex="-1" aria-hidden="true" style={{top : '20%'}}>
				<div className="modal-content">
					<h4 className="modal-title"></h4>
				</div>
				<div className="modal-body">
                    {this.props.children}
                </div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/UserProfileModal/Modal.js
 **/